module.exports = __webpack_public_path__ + "static/media/congrat.5eb7ae40.png";